import React from 'react';
import { Tab, withStyles } from '@material-ui/core';

const StyledTab = withStyles((theme) => ({
  root: {
    color: theme.palette.general.grey100,
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(14),
    marginRight: theme.spacing(1),
    minHeight: 42,
    '&.Mui-selected': {
      color: theme.palette.primary.main,
    },
    '&:focus': {
      opacity: 1,
    },
  },
}))((props) => {
  return <Tab disableRipple {...props} />;
});

export default StyledTab;
